





















/**
 * @author wangyingxu1
 * 集团教研平台子系统路由tab
 */

import { Component, Prop, Emit, Watch, Vue } from 'vue-property-decorator';

@Component({})
export default class MenuTab extends Vue {
  @Prop({ type: Array, default: (): any[] => ([]) }) public menuTab!: any[];

  public currentTab: string = '';

  @Watch('menuTab')
  public menuTabChange(): void {
    if (!this.menuTab.length) {
      return;
    }
    this.selectCurrentTab();
  }

  public selectCurrentTab(): void {
    const herf: string = window.location.href;
    const currentTabItem: any = this.menuTab.find((item: any): boolean => herf.indexOf(item.menuUrl) !== -1);
    if (!currentTabItem) {
      this.tabChange(this.menuTab[0]);
      return;
    }
    this.currentTab = currentTabItem.id;
  }

  public tabChange(tab: any): void {
    if (tab.id === this.currentTab) {
      return;
    }
    this.currentTab = tab.id;
    this.emitChange(tab);
  }

  @Emit('change')
  public emitChange(tab: any): void {
    return tab;
  }
}

